const { html, supportUrl } = window;
const {supportArticles, _locale} = window.OverDrive;

export default (alternativeButtonText) => `
    <div class='message-container'>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.sorry')}</p>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.useReadHtml', {option: `
            <span style='font-weight: bold'>${alternativeButtonText}</span>
        `})}</p>
    </div>
    <div class='futureAction-container'>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.futureActionHtml', {checkRestrictions: `
            <a target='_blank' href='${supportUrl(_locale, supportArticles.deviceRestrictions)}'>${html('kindleFulfillment.kindleTroubleResponseModal.checkRestrictions')}</a>
        `})}</p>
    </div>
    <div class='button-container'>
        <button type='button' class='confirm-button button radius secondary contrast u-allCaps u-center'>${html('ok')}</button>
    </div>
`;
